import { MEDREFILL_ROUTES } from './routes';
import { MEDREFILL_OTHERS_ROUTE } from './routes-others';
import { MEDREFILL_PUBLIC_ROUTES } from './routes-public';

export const MEDREFILL_MODULE_ROUTES = [...MEDREFILL_ROUTES, ...MEDREFILL_OTHERS_ROUTE, ...MEDREFILL_PUBLIC_ROUTES];
